<template>
  <div class="request-list-container">
    <div class="horizontal p-2" style="width: 100%;">
      <div class="column10 text-red">Notifikasi</div>
      <div class="cursor-pointer" @click="readAll()">Read All</div>
    </div>
    <div class="request-list-wrapper">
      <div class="request-table">
        <!-- <div class="request-table-list request-table-border table-flex">
          NOTIFIKASI
        </div> -->
        <div class="request-table-list cursor-pointer" v-for="(item, index) in $store.state.notifStore.list"
          :key="index">
          <div class="mb10" @click="showDetail(item.route, item.id, item.is_open)">
            <div :style="`color: ${item.is_open ? 'grey' : 'black'}`">
              {{ item.desc }}
            </div>

            <div :style="`color: ${item.is_open ? 'grey' : 'black'}; font-size: 12px`
              ">
              Pertama dilihat oleh: {{ item.open_by ? item.open_by : '-' }}
            </div>
            <div :style="`color: ${item.is_open ? 'grey' : 'black'}; font-size: 12px`
              ">
              Terakhir dilihat oleh: {{ item.last_open ? item.last_open : '-' }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="request-pagination">
        <div class="mlp-pagination-wrapper-level1">
          <b-pagination
            aria-controls="isupplier-table"
            v-model="page"
            :total-rows="totalItems"
            :per-page="perPage"
            align="fill"
            class="mlp-pagination"
          ></b-pagination>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  created() {
    this.$store.dispatch('notifStore/getNotifWithLoading', {
      id: this.$store.state.role_id,
    })
  },
  computed: {},
  methods: {
    async showDetail(url, id, status) {
      const route = url.split('#')[1]

      if (!status) {
        await this.$store.dispatch('notifStore/updateNotif', {
          id,
          name: this.$store.state.currentUser,
          role_id: this.$store.state.role_id,
          open_by: this.$store.state.currentUser,
          last_open: this.$store.state.currentUser,
          status,
        })
      } else {
        await this.$store.dispatch('notifStore/updateNotif', {
          id,
          name: this.$store.state.currentUser,
          role_id: this.$store.state.role_id,
          last_open: this.$store.state.currentUser,
          status,
        })
      }

      await this.$router.push(route)
    },

    async readAll() {
      await this.$store.dispatch('notifStore/readAllNotif', {
        name: this.$store.state.currentUser,
        role_id: this.$store.state.role_id,
        last_open: this.$store.state.currentUser,
      })
    },
  },
}
</script>
